import { render } from "./workSpaceView.vue?vue&type=template&id=6571e3c2&scoped=true"
import script from "./workSpaceView.vue?vue&type=script&lang=js"
export * from "./workSpaceView.vue?vue&type=script&lang=js"

import "./workSpaceView.vue?vue&type=style&index=0&id=6571e3c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6571e3c2"]])

export default __exports__